import React from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface ContactProps {
  cookiesAccepted: boolean;
}

const Contact: React.FC<ContactProps> = ({ cookiesAccepted }) => {
  const { t } = useTranslation();

  return (
    <Container className="my-5" style={{ paddingTop: "130px" }}>
      <h2 className="fw-bold text-center mb-4 text-wazny">{t("contactTitleNiedzica")}</h2>
      <p className="text-center">{t("contactPhoneNiedzica")}</p>
      <p className="text-center">{t("contactEventsNiedzica")}</p>
      <p className="text-center">{t("contactAddressNiedzica")}</p>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
          minHeight: "450px",
        }}
      >
        {cookiesAccepted ? (
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10381.70393493845!2d20.324297439582097!3d49.419760027017205!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x473e025eadb03f8f%3A0xd8ffbd996c7fb4bf!2sKarczma%20%22Zadyma%22!5e0!3m2!1spl!2spl!4v1748090570760!5m2!1spl!2spl"
            width="600"
            height="450"
            style={{ border: 0 }}
            title={t("contactTitleNiedzica")}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        ) : (
          <p className="text-center">{t("cookieMessageMapHidden") || "Mapa jest ukryta do momentu zaakceptowania plików cookie."}</p>
        )}
      </div>

      <br />
      <h2 className="fw-bold text-center mb-4 text-wazny">{t("contactTitleSzaflary")}</h2>
      <p className="text-center">{t("contactEventsSzaflary")}</p>
      <p className="text-center">{t("contactPhoneSzaflary")}</p>
      <p className="text-center">{t("contactOrdersSzaflary")}</p>
      <p className="text-center">{t("contactAddressSzaflary")}</p>
      <p className="text-center">{t("contactEmailSzaflary")}</p>
    </Container>
  );
};

export default Contact;
